import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { InfrastructureProjectType } from '../../../types/project.types';
import { getInfrastructureProjectById } from '../../../requests/public-infrastructure';
import classes from './styles.module.scss';
import EducationTab from '../tabs/infrastructure-project-tabs/education-tab.component';
import HealthTab from '../tabs/infrastructure-project-tabs/health-tab.component';
import CultureTab from '../tabs/infrastructure-project-tabs/culture-tab.component';
import AccessRoadTab from '../tabs/infrastructure-project-tabs/access-road-tab.component';
import WaterSupplyTab from '../tabs/infrastructure-project-tabs/water-supply-tab.component';
import InternetTab from '../tabs/infrastructure-project-tabs/internet-tab.component';
import VillageRoadTab from '../tabs/infrastructure-project-tabs/village-road-tab.component';
import LightingTab from '../tabs/infrastructure-project-tabs/lighting-tab.component';
import InvestmentProjectTab from '../tabs/investment-project-tab.component';
import ImprovementProjectTab from '../tabs/improvement-project-tab.component';

const baseClass = 'project-details';

const ProjectDetails = () => {
  const { kato, tab, id, link } = useParams<{ tab: string; kato: string; id: string; link: string }>();
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    loadData();
  }, [tab, id, kato, link]);

  const loadData = () => {
    if (link && ![InfrastructureProjectType.SNP_INVESTMENT, InfrastructureProjectType.SNP_IMPROVEMENT].includes(link as InfrastructureProjectType)) {
      if (!id || !tab) return;
      getInfrastructureProjectById(tab as InfrastructureProjectType, Number(id)).then((project) => {
        setData(project);
      }).catch((error) => {
        console.error('Error fetching project details:', error);
        setData(null);
      });
    } else {
      if (!tab) return;
      getInfrastructureProjectById(link as InfrastructureProjectType, Number(tab)).then((project) => {
        setData(project);
      }).catch((error) => {
        console.error('Error fetching investment project details:', error);
        setData(null);
      });
    }
  }


  return (
    tab && data && <div className={classes[baseClass]}>
      {tab === InfrastructureProjectType.EDUCATION && <EducationTab data={data} loadData={loadData} />}
      {tab === InfrastructureProjectType.HEALTH && <HealthTab data={data} loadData={loadData} />}
      {tab === InfrastructureProjectType.CULTURE_SPORT && <CultureTab data={data} loadData={loadData} />}
      {tab === InfrastructureProjectType.WATER_SUPPLY && <WaterSupplyTab data={data} loadData={loadData} />}
      {tab === InfrastructureProjectType.ACCESS_ROAD && <AccessRoadTab data={data} loadData={loadData} />}
      {tab === InfrastructureProjectType.INTERNET_COMMUNICATION && <InternetTab data={data} loadData={loadData} />}
      {tab === InfrastructureProjectType.VILLAGE_ROAD && <VillageRoadTab data={data} loadData={loadData} />}
      {tab === InfrastructureProjectType.LIGHTING && <LightingTab data={data} loadData={loadData} />}
      {link === InfrastructureProjectType.SNP_INVESTMENT && <InvestmentProjectTab data={data} loadData={loadData} />}
      {link === InfrastructureProjectType.SNP_IMPROVEMENT && <ImprovementProjectTab data={data} loadData={loadData} />}
    </div >
  )
}

export default ProjectDetails